import { defineDashboard } from '@/admin/dashboards/defineDashboard';

export const aiTutorDashboardDefinition = defineDashboard({
  id: 'ai-tutor',
  metrics: [
    'ai_assist_scope',
    'attempts_to_done',
    'score_gain_per_attempt',
    'helpful_share',
    'vote_rate',
    'paste_heavy_share',
    'stuck_students',
    'score_by_attempt',
    'score_by_session_week',
    'helpful_votes:week',
    'vote_rate:week',
  ],
  filterNames: ['gated', 'from', 'to', 'excludePasteHeavy', 'excludeFirstTryPasses'],
  titleKey: 'admin.analytics.aiTutor.title',
  subtitleKey: 'admin.analytics.aiTutor.subtitle',
});
